import Vue from 'vue'
import { Button, Select,Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import './plugins/element.js'
import router from './router/index.js'
import store from './store/index.js'
Vue.config.productionTip = false

 Vue.use(Button)
  Vue.use(Select)
    Vue.use(Pagination)
  
new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
